import { useQuery } from "@apollo/client/react"; import { Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';

import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';

export const StepProgramaAE = ({
  esAdulto,
  setDataSubmissionCallback,
  updateFormData,
  fullFormDataRI
}) => {

  const [datosProgramaAE, setDatosProgramaAE] = useState(fullFormDataRI?.programaAE1 ?? {});
  const [combosRI, setCombosRI] = useState();

  const inputCombos = inputsGroups.flatMap((inputgroup) => {
    return inputgroup.inputs.filter((input) => !!input.comboName);
  });

  const handleSubmit = () => {
    updateFormData('programaAE1', datosProgramaAE, parsedInputsGroup.flatMap((x) => x.inputs));
  };

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);

  const handleChange = (name, value) => {
    setDatosProgramaAE((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const parsedInputsGroup = useMemo(() => {

    const filteredGroups = esAdulto ? inputsGroups : inputsGroups.filter((group) => !group.esAdulto);

    if (!combosRI) return filteredGroups;

    return filteredGroups.map((group) => ({
      ...group,
      inputs: group.inputs.map((input) => {
        if (!!input.comboName) {
          input.options = combosRI[input.name];
        }
        switch (input.name) {
          case 'justificacionNoCambioSNG':
            const cambioSNGNo = datosProgramaAE.cambioSNGdomicilio === false;
            input.required = cambioSNGNo;
            input.disabled = !cambioSNGNo;
            if (!cambioSNGNo) handleChange('justificacionNoCambioSNG');
            break;
          case 'justificarMalEstado':
            const accesoNo = datosProgramaAE.accesoBuenEstado === false;
            input.required = accesoNo;
            input.disabled = !accesoNo;
            if (!accesoNo) handleChange('justificarMalEstado');
            break;
          default:
            break;
        }
        return input;
      })
    }));
  }, [esAdulto, combosRI, datosProgramaAE.cambioSNGdomicilio, datosProgramaAE.accesoBuenEstado]);

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [datosProgramaAE, setDataSubmissionCallback, parsedInputsGroup]);

  return (
    <div>
      {parsedInputsGroup.map((group) =>
        <>
          {group.notGrouped && <Grid container>
            {group.inputs.map((input) => {
              return (
                <RenderInputByTypeMobile
                  key={`${group.groupName}-${input.name}`}
                  grided
                  handleChange={handleChange}
                  input={input}
                  value={datosProgramaAE[input.name]} />);


            })}
          </Grid>}
          {!group.notGrouped && <div className='step-form-section-container' key={group.groupName}>
            <label className='step-form-section-title'>{group.groupName}</label>
            <Grid container>
              {group.inputs.map((input) => {
                return (
                  <RenderInputByTypeMobile
                    key={`${group.groupName}-${input.name}`}
                    grided
                    handleChange={handleChange}
                    input={input}
                    value={datosProgramaAE[input.name]} />);


              })}
            </Grid>
          </div>}
        </>
      )}
    </div>);

};

const inputsGroups = [
  {
    notGrouped: true,
    esAdulto: true,
    inputs: [
      {
        name: 'idComboRIValorKarnofsky',
        displayName: 'Karnofsky',
        comboName: 'Karnofsky',
        required: true,
        type: 'select'
      }]

  },
  {
    groupName: 'Requerimientos',
    inputs: [
      {
        name: 'proteinasTotales',
        displayName: 'Proteínas Totales/d',
        required: true,
        type: 'int'
      },
      {
        name: 'caloriasTotales',
        displayName: 'Calorías Totales/d',
        required: true,
        type: 'int',
        max: 3500
      }]

  },
  {
    groupName: 'Accesos enterales',
    inputs: [
      {
        name: 'idComboRIValorTipoAccesoAE',
        displayName: 'Tipo de Acceso',
        comboName: 'Tipo de Acceso',
        required: true,
        type: 'select'
      },
      {
        name: 'cambioSNGdomicilio',
        displayName: 'Cambio de SNG en Domicilio?',
        required: true,
        type: 'boolean'
      },
      {
        name: 'justificacionNoCambioSNG',
        displayName: 'Si es No Justificar',
        required: false,
        type: 'string'
      },
      {
        name: 'accesoBuenEstado',
        displayName: 'Acceso enteral en buen estado?',
        required: true,
        type: 'boolean'
      },
      {
        name: 'justificarMalEstado',
        displayName: 'Si es No Justificar',
        required: false,
        type: 'string'
      }]

  }];